import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { isUSTerritoryProject } from 'common/helpers/projectInitUtil';
import { useSelector } from 'react-redux';
import { getProjectTerritory } from 'features/project/projectSlice';
import { Dialog } from './Dialog';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const LightThemeDialog = ({ open, onConfirm, onClose }: Props) => {
  const { t } = useTranslation();
  const territory = useSelector(getProjectTerritory);
  const isUSTerritory = isUSTerritoryProject(territory);

  const title = (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <InfoIcon
        sx={{
          color: 'text.secondary',
          mr: '0.75rem',
        }}
      />

      {t('projectSetLight')}
    </Box>
  );

  const content = (
    <>
      <Box mb="1rem">
        {isUSTerritory ? (
          <>{t('usCustomcolorThemeMessage')}</>
        ) : (
          <>{t('customcolorThemeMessage')}</>
        )}
      </Box>
    </>
  );
  const actions = (
    <>
      <Button
        variant="outlined"
        size="large"
        onClick={onConfirm}
        sx={{
          width: '5.688rem',
          height: '3rem',
        }}
      >
        {t('close')}
      </Button>
    </>
  );

  return (
    <Dialog
      content={content}
      title={title}
      open={open}
      actions={actions}
      onClose={onClose}
    />
  );
};
